export const translations = {
  en: {
    review: {
      reviewPageIntro:
        'Review and edit any personal information that has changed',
      patientFirstName: 'First name',
      patientLastName: 'Last name',
      patientName: 'Name',
      raceEthnicity: 'Race & ethnicity',
      patientHomePhone: 'Home phone',
      patientCellPhone: 'Mobile phone',
      patientWorkPhone: 'Work phone',
      patientEmployerPhone: 'Employer phone',
      patientPhoneNumber: 'Phone number',
      patientEmail: 'Email',
      patientAddressMailing: 'Mailing address',
      patientAddressPhysical: 'Physical address',
      patientDob: 'Date of birth',
      patientRace: 'Race',
      patientReligion: 'Religion',
      patientEthnicity: 'Ethnicity',
      patientMaritalStatus: 'Marital status',
      patientCareProviders: 'Primary care provider',
      patientDependents: 'Dependents',
      patientBreastFeeding: 'Breast feeding',
      patientCovidVaccineInPastFourWeeks: 'Covid vaccine in past four weeks',
      patientPatientInstitutionId: 'Patient institution ID',
      patientMothersFirstName: "Mother's firstName",
      patientUseEmail: 'Use email',
      patientAccommodations: 'Accommodations',
      patientsEnglishFluency: 'English fluency',
      patientHomeless: 'Homeless',
      patientInterpreterNeeded: 'Interpreter needed',
      patientOccupation: 'Occupation',
      patientPhotoIdUpload: 'Identification',
      patientPreferredContactMethod: 'Preferred contact method',
      patientPreferredFirstName: 'Preferred first name',
      patientPreferredLastName: 'Preferred last name',
      patientPreferredLanguage: 'Preferred language',
      patientPreferredPhone: 'Preferred phone',
      patientWrittenLanguage: 'Preferred written language',
      patientEmployer: 'Employer',
      patientSex: 'Sex',
      surgeryName: '{{name}} ({{date}})',
      patientVeteranStatus: 'Veteran status',
      patientVideoVisitCapabilities: 'Video visit capabilities',
      phone: 'Phone',
      guarantorRelationshipToPatient: 'Relationship to patient',
      guarantorSex: 'Sex',
      guarantorEmail: 'Email',
      guarantorMailingAddress: 'Mailing address',
      guarantorPhoneNumber: 'Phone number',
      guarantorNotFound: 'No guarantors found',
      update: 'Update my information',
      continue: 'Continue',
      insuranceProvider: 'Insurance Provider',
      cardCountKey: 'Insurance Card',
      cardCountValue: '{{count}} card on file',
      cardCountValue_plural: '{{count}} cards on file',
      insuranceId: 'Insurance Id ',
      cardNumber: '(Card {{cardNumber}})',
      patientEmploymentStatus: 'Employment status',
      patientEmergencyContact: 'Emergency contact',
      patientGuarantors: 'Person responsible for medical bills',
      personalInformationTitleKey: 'Personal Information',
      pharmacyTitleKey: 'Pharmacy',
      patientCondition: 'Condition',
      primaryCareProviderTitleKey: 'Primary Care Provider',
      allergiesTitleKey: 'Allergies',
      emergencyContactTitleKey: 'Emergency Contact',
      emergencyContactsTitleKey: 'Emergency Contacts',
      familyMedicalHistoryTitleKey: 'Family medical history',
      personalMedicalHistoryTitleKey: 'Personal medical history',
      demographicsTitleKey: 'Demographics',
      careProvidersTitleKey: 'Primary care provider',
      guarantorTitleKey: 'Guarantor',
      insuranceCardsTitleKey: 'Insurance Cards',
      identificationTitleKey: 'Identification',
      additionalInformationTitleKey: 'Additional Information',
      emergencyContactNameLabel: 'Name',
      emergencyContactRelationshipLabel: 'Relationship',
      emergencyRelativeContactRelationshipLabel:
        'Patient relationship to contact',
      emergencyContractPhoneNumberLabel: 'Phone number',
      policyHolderLabel: 'Policy holder',
      memberIdLabel: 'Member ID',
      groupNumberLabel: 'Group number',
      coverageStartDateLabel: 'Coverage start date',
      primaryCareProviderNameLabel: 'Name',
      primaryCareProviderPhoneNumberLabel: 'Phone number',
      primaryCareProviderAddress: 'Address',
      pharmacyAddress: 'Address',
      payingWithInsurance: 'Paying with insurance',
      insuranceCardNamePlaceHolder: 'Insurance Card',
      noInsuranceMessage:
        'No insurance cards on file. Add one today to prevent billing issues.',
    },
  },
  es: {
    review: {
      reviewPageIntro:
        'Revise y edite cualquier información personal que haya cambiado',
      patientFirstName: 'Nombre',
      patientLastName: 'Apellidos',
      patientName: 'Nombre',
      raceEthnicity: 'Raza y origen étnico',
      patientHomePhone: 'Teléfono de casa',
      patientCellPhone: 'Teléfono celular',
      patientWorkPhone: 'Teléfono del trabajo',
      patientEmployerPhone: 'Teléfono del empleador',
      patientPhoneNumber: 'Número de teléfono',
      patientEmail: 'Correo electrónico',
      patientAddressMailing: 'Dirección de envío',
      patientAddressPhysical: 'Dirección física',
      patientDob: 'Fecha de nacimiento',
      patientRace: 'Raza',
      patientReligion: 'Religión',
      patientEthnicity: 'Origen étnico',
      patientMaritalStatus: 'Estado civil',
      patientCareProviders: 'Médico de atención primaria',
      patientDependents: 'Dependientes',
      patientBreastFeeding: 'Lactancia materna',
      patientCovidVaccineInPastFourWeeks:
        'Vacuna Covid en las últimas cuatro semanas.',
      patientPatientInstitutionId: 'ID de la institución del paciente',
      patientMothersFirstName: 'Nombre de la madre',
      patientUseEmail: 'Usar correo electrónico',
      patientAccommodations: 'Comodidades',
      patientsEnglishFluency: 'Fluidez en inglés',
      patientHomeless: 'Sin hogar',
      patientInterpreterNeeded: 'Se necesita intérprete',
      patientOccupation: 'Ocupación',
      patientPhotoIdUpload: 'Identificación',
      patientPreferredContactMethod: 'Método de contacto preferente',
      patientPreferredFirstName: 'Nombre preferente',
      patientPreferredLastName: 'Apellido preferente',
      patientPreferredLanguage: 'Idioma preferente',
      patientPreferredPhone: 'Teléfono preferente',
      patientWrittenLanguage: 'Idioma escrito preferente',
      patientEmployer: 'Empleador',
      patientSex: 'Sexo',
      patientVeteranStatus: 'Condición de veterano',
      patientVideoVisitCapabilities: 'Opciones de visita por vídeo',
      phone: 'Teléfono',
      guarantorRelationshipToPatient: 'Relación con el paciente',
      guarantorSex: 'Sexo',
      guarantorEmail: 'Correo electrónico',
      guarantorMailingAddress: 'Dirección de envío',
      guarantorPhoneNumber: 'Número de teléfono',
      update: 'Actualizar mi información',
      continue: 'Continuar',
      insuranceProvider: 'Proveedor de seguros',
      cardCountKey: 'Tarjeta de seguro',
      cardCountValue: '{{count}} tarjeta registrada',
      cardCountValue_plural: '{{count}} tarjetas registradas',
      insuranceId: 'ID del seguro',
      cardNumber: '(Tarjeta {{cardNumber}})',
      patientEmploymentStatus: 'Estado laboral',
      patientEmergencyContact: 'Contacto de emergencia',
      patientGuarantors: 'Persona responsable de las facturas médicas',
      personalInformationTitleKey: 'Información personal',
      primaryCareProviderTitleKey: 'Médico de atención primaria',
      emergencyContactTitleKey: 'Contacto de emergencia',
      emergencyContactsTitleKey: 'Contactos de emergencia',
      demographicsTitleKey: 'Demografía',
      careProvidersTitleKey: 'Médico de atención primaria',
      guarantorTitleKey: 'Garantía',
      insuranceCardsTitleKey: 'Tarjetas de seguro',
      identificationTitleKey: 'Identificación',
      additionalInformationTitleKey: 'Información adicional',
      emergencyContactNameLabel: 'Nombre',
      emergencyContactRelationshipLabel: 'Relación',
      emergencyRelativeContactRelationshipLabel:
        'Relación del paciente con el contacto',
      emergencyContractPhoneNumberLabel: 'Número de teléfono',
      policyHolderLabel: 'Titular de la póliza',
      memberIdLabel: 'ID de miembro',
      groupNumberLabel: 'Número de grupo',
      coverageStartDateLabel: 'Fecha de inicio de cobertura',
      primaryCareProviderNameLabel: 'Nombre',
      primaryCareProviderPhoneNumberLabel: 'Número de teléfono',
      payingWithInsurance: 'Pagando con seguro',
      insuranceCardNamePlaceHolder: 'Tarjeta de seguro',
      noInsuranceMessage:
        'No hay tarjetas de seguro registradas. Agregue una hoy para evitar problemas de facturación.',
      noEmergencyContacts: 'No emergency contacts',
      addEmergencyContacts: 'Add emergency contacts',
    },
  },
};
